import { useWizard } from 'react-use-wizard';
import { useState } from 'react';
import DesignItem from '../components/DesignItem';
function DesignStep({ values, placements = [], handleSaveDesigns, handleDeleteDesign }) {
   const { previousStep, goToStep } = useWizard();
   const [designs, setDesigns] = useState(values && values.length ? values : [{ id: 1, name: '' }]);
   const handleChangeDesign = (index, value, price) => {
      const designsCopy = [...designs];
      designsCopy[index] = { ...designsCopy[index], value, price };
      setDesigns(designsCopy);
   };
   const handleAddDesign = () => {
      if (designs.length) {
         const lastDesignId = designs[designs.length - 1].id;
         setDesigns([...designs, { id: lastDesignId + 1 }]);
      } else {
         setDesigns([{ id: 1, name: '' }]);
      }
   };
   const handleChangeDesignName = (index, value) => {
      const designsCopy = [...designs];
      designsCopy[index] = { ...designsCopy[index], name: value };
      setDesigns(designsCopy);
   };
   const deleteDesign = index => {
      const designsCopy = [...designs];
      designsCopy.splice(index, 1);
      setDesigns(designsCopy);
      handleDeleteDesign(index, designsCopy);
   };
   const handleSubmit = () => {
      handleSaveDesigns(designs);
      goToStep(4);
   };
   return (
      <div className="step">
         <div className="step__container">
            <div className="step__content">
               <div className="step__hint">створіть дизайн принта</div>

               <div className="step__design-items">
                  {designs.map((design, index) => (
                     <DesignItem
                        key={index}
                        items={placements}
                        name={design.name}
                        values={design.value}
                        onChange={value => handleChangeDesign(index, value)}
                        handleChangeDesignName={(value, price) => handleChangeDesignName(index, value, price)}
                        handleDeleteDesign={() => deleteDesign(index)}
                     />
                  ))}
               </div>
               <p className="step__design-caption">
                  * Ціна на дизайн є орієнтовною, дизайн макети для друку надаються менеджеру та узгоджуються
                  персонально.
               </p>

               <p onClick={handleAddDesign} className="step__design-add">+{' '}додати дизайн</p>
            </div>
         </div>
         <div className="step__navigation">
            <button className="step__navigation-item" onClick={() => previousStep()}>
               назад
            </button>
            <button className="step__navigation-item" onClick={handleSubmit}>
               далі
            </button>
         </div>
      </div>
   );
}

export default DesignStep;
